import type { FilterValues } from './Filters.types'

export const DEFAULT_INITIAL_VALUES: FilterValues = {
  market: '',
  categoryId: '',
  sku: '',
  priceDifference: '',
}

export const VALUE_ALL = 'ALL'
